module.exports = __webpack_public_path__ + "static/media/icoke-mobile.66b3c349.jpg";